<template>
    <transition name="splash">
        <div
            id="splashscreen-wrapper"
            class="fixed z-50 inset-0 size-full bg-green-400"
            v-if="isMobile && isVisible"
        >
            <div
                class="absolute inset-0 flex justify-center items-center size-full"
            >
                <div
                    id="splashscreen-text"
                    class="flex items-center flex-col gap-2 text-green-800 font-heading text-2xl font-bold leading-tight"
                >
                    <div
                        class="text-green-400 bg-green-800 size-7 rounded-full flex justify-center items-center"
                    >
                        <div class="transform scale-125">
                            <check-icon />
                        </div>
                    </div>
                    Payment successful
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import isMobile from '@/helpers/isMobileDevice';
import CheckIcon from '@/components/icons/CheckIcon.vue';

export default {
    name: 'PaymentSuccessSplashScreen',
    components: {
        CheckIcon
    },
    data() {
        return {
            isVisible: false
        };
    },
    computed: {
        isMobile() {
            return isMobile();
        }
    },
    mounted() {
        this.isVisible = true;

        setTimeout(() => {
            this.$emit('closed');
            this.isVisible = false;
        }, 3500);
    }
};
</script>

<style src="@/assets/css/thank-you-splash-screen.css" scoped />
